<template>
  <vs-tabs position="top" class="tabs-shadow-none" id="installment-calculation-tabs">
    <vs-tab icon-pack="feather" icon="icon-settings"
            :label="'คำนวนเงินงวด (ปกติ)'">
      <InstallmentCalculationCard/>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-settings"
            :label="'คำนวนเงินงวด (ปรับโครงสร้างหนี้)'">
      <InstallmentCalculationRestructuringCard/>
    </vs-tab>
  </vs-tabs>
</template>

<script>

import {ValidationProvider} from "vee-validate";
import {createNamespacedHelpers} from "vuex";
import InstallmentCalculationCard
  from "@/views/pages/HeaderMenu/InstallmentCalculation/Components/InstallmentCalculationCard/InstallmentCalculationCard.vue";
import InstallmentCalculationRestructuringCard
  from "@/views/pages/HeaderMenu/InstallmentCalculation/Components/InstallmentCalculationRestructuringCard/InstallmentCalculationRestructuringCard.vue";

const { mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  components: {
    InstallmentCalculationCard,
    InstallmentCalculationRestructuringCard,
    ValidationProvider,
  },
  computed: {
    ...mapSystemState(['status']),
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
};
</script>
